 <app-table-title [introText]="introText" [title]="'REPORTS' | dictionary">
   <button class="button-1" (click)="askConfirmation()">{{'NEW_POSITION_FILE' | dictionary}}</button>
 </app-table-title>
 <div class="row table-container"
      [class.with-padding-for-buttons]="rowSelectionList && rowSelectionList.length > 0">
   <div class="col-lg-12 table-container">
     <kendo-grid [data]="reports"
                 [navigable]="false"
                 [resizable]="true"
                 [loading]="loading"
                 [sortable]="{allowUnsort: false, mode: 'single'}"
                 [sort]="sort"
                 [selectedKeys]="rowSelectionList"
                 [kendoGridSelectBy]="'SeqNum'"
                 (sortChange)="sortChange($event)"
                 (scrollBottom)="loadMore()"
                 (selectionChange)="onSelection($event)"
     >
       <kendo-grid-checkbox-column showSelectAll="true" [style]="{'text-align':'center'}"
                                   [headerClass]="'k-checkbox-all gridheader text-color-1'" [width]="25">
       </kendo-grid-checkbox-column>

       <kendo-grid-column [headerClass]="'gridheader '" field="Label" [width]="200"
                          title="{{'REPORTS_NAME' | dictionary}}"></kendo-grid-column>

       <kendo-grid-column [headerClass]="'gridheader '" field="Created" [width]="100"
                          title="{{'DATE' | dictionary}}">
         <ng-template kendoGridCellTemplate let-dataItem>
           <div>{{ dataItem.Created | date: "MM/dd/yyyy, h:mm a" }}</div>
         </ng-template>
       </kendo-grid-column>



       <kendo-grid-column [headerClass]="'gridheader text-color-1 text-center'" field="SeqNum" title="{{'DOWNLOAD' | dictionary}}"
                          width="50" align="center" [sortable]="false">
         <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
           <span>{{'DOWNLOAD' | dictionary}}</span>
         </ng-template>
         <ng-template kendoGridCellTemplate let-dataItem>

           <div class="download-icon text-center" *ngIf="dataItem.DocSeqNum != 0"
                (click)="downloadDocument($event, dataItem.DocSeqNum, dataItem.FileNum)">
             <i class="fas fa-file-download icon"></i>
           </div>

           <div class="text-center" *ngIf="dataItem.DocSeqNum === 0">
             {{'PENDING' | dictionary}}
           </div>

         </ng-template>
       </kendo-grid-column>
     </kendo-grid>
   </div>
 </div>

 <div class="download-wrapper"
      *ngIf="rowSelectionList && rowSelectionList.length > 0">
   <button type="button" class="button-1" (click)="downloadSelected()">
     <i class="fa fa-download"></i>
     <span *ngIf="rowSelectionList.length === 1"> {{'DOWNLOAD_FILE' | dictionary}}</span>
     <span
       *ngIf="rowSelectionList.length > 1"> {{'DOWNLOAD_FILES' | dictionary : (isAllSelected ? totalRecords : rowSelectionList.length)}}</span>
   </button>
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
 </app-pop-up-dialog>


 <app-pop-up-confirmation [cancelButton]="'CANCEL'" [confirmButton]="'CONTINUE'"
                          [Message]="alertMessage" [Display]="displayConfirmationPopup"
                          (DisplayBack)="displayConfirmationPopup = false; addNewReport($event)"></app-pop-up-confirmation>
